module.exports = __webpack_public_path__ + "img/EllipseFeatures.de7c620e.svg";